import { INotification, IPublishState, NotificationPublishStatus } from '@communication-center/data-objects';

export interface IAnalyticsData {
    received?: number;
    views?: number;
    clicks?: number;
    engagement?: number;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface Notification extends INotification {
    analytics?: IAnalyticsData;
    isAllAudienceSelected?: boolean;
}

export const getNotificationPublishState = (notification?: Notification, environmentId?: string): IPublishState | never | undefined => {
    if (!environmentId) throw 'environment is required!';

    return notification?.publishStates?.find(ps => ps.environmentId === environmentId);
};

export const setNotificationPublishState = (notification: Notification, publishState: IPublishState): void => {
    if (!publishState.environmentId) {
        throw 'publish-state must have environmentId';
    }
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const existingPublishState = notification.publishStates.find(ps => ps.environmentId === publishState.environmentId);

    if (existingPublishState) {
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        notification.publishStates = notification.publishStates.map(ps => (ps.environmentId === publishState.environmentId ? publishState : ps));
    } else {
        // @ts-expect-error ts-migrate(2461) FIXME: Type 'IPublishState[] | undefined' is not an array... Remove this comment to see the full error message
        notification.publishStates = [...notification.publishStates, publishState];
    }
};

export const isNotificationActive = (notification: Notification, environmentId: string): boolean => {
    const ps = getNotificationPublishState(notification, environmentId);
    return (
        ps?.publishStatus !== NotificationPublishStatus.Deleted &&
        ps?.publishStatus !== NotificationPublishStatus.Draft &&
        !!ps?.startAt &&
        new Date(ps.startAt) <= new Date() &&
        !!ps?.endAt &&
        new Date(ps.endAt) > new Date()
    );
};

export const isNotificationScheduled = (notification: Notification, environmentId: string) => {
    const ps = getNotificationPublishState(notification, environmentId);
    return (
        ps?.publishStatus !== NotificationPublishStatus.Deleted &&
        ps?.publishStatus !== NotificationPublishStatus.Draft &&
        ps?.startAt &&
        new Date(ps.startAt) > new Date()
    );
};

export const isNotificationPaused = (notification: Notification, environmentId: string) => {
    return getNotificationPublishState(notification, environmentId)?.publishStatus === NotificationPublishStatus.Paused;
};

export const isNotificationOld = (notification: Notification, environmentId: string) => {
    const ps = getNotificationPublishState(notification, environmentId);
    return (
        ps?.publishStatus !== NotificationPublishStatus.Deleted &&
        ps?.publishStatus !== NotificationPublishStatus.Draft &&
        ps?.endAt &&
        new Date(ps.endAt) < new Date()
    );
};

export const isNotificationDeleted = (notification: Notification, environmentId: string) => {
    return getNotificationPublishState(notification, environmentId)?.publishStatus === NotificationPublishStatus.Deleted;
};

export const isDraftNotification = (notification: Notification, environmentId: string) => {
    return getNotificationPublishState(notification, environmentId)?.publishStatus === NotificationPublishStatus.Draft;
};
